import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-3" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <FadeIn className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8 text-center relative overflow-hidden shadow-xl" data-id="element-80">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-accent" data-id="element-81" />

          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent/10 mb-3" data-id="element-82">
            <ShieldCheck size={32} className="text-accent" data-id="element-83" />
          </div>

          <h2 className="font-display text-2xl md:text-3xl font-bold mb-3 text-accent" data-id="element-84">
            GARANTÍA SISTEMA CLÍNICO — 7 DÍAS
          </h2>

          <div className="space-y-2 text-base md:text-lg text-white/80 max-w-2xl mx-auto" data-id="element-85">
            <p data-id="element-86">
              Abrís los 6 tomos. Revisás los bonos. Los usás en consulta clínica
              si querés.
            </p>
            <p className="font-bold text-accent" data-id="element-87">
              Si en 7 días no era lo que esperabas: Te devolvemos el 100%.
            </p>
            <p data-id="element-88">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}